import Vue from "vue";
import Vuetify, { colors } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.red.lighten2,
        secondary: colors.blueGrey
      }
    },
    options: {
      customProperties: true // Allows for colours to be used in component css with var(--v-primary-base) || var(--v-accent-lighten2) etc.
    }
  }
});
